"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconErrorType = void 0;
var BeaconErrorType;
(function (BeaconErrorType) {
    BeaconErrorType["BROADCAST_ERROR"] = "BROADCAST_ERROR";
    BeaconErrorType["NETWORK_NOT_SUPPORTED"] = "NETWORK_NOT_SUPPORTED";
    BeaconErrorType["NO_ADDRESS_ERROR"] = "NO_ADDRESS_ERROR";
    BeaconErrorType["NO_PRIVATE_KEY_FOUND_ERROR"] = "NO_PRIVATE_KEY_FOUND_ERROR";
    BeaconErrorType["NOT_GRANTED_ERROR"] = "NOT_GRANTED_ERROR";
    BeaconErrorType["PARAMETERS_INVALID_ERROR"] = "PARAMETERS_INVALID_ERROR";
    BeaconErrorType["TOO_MANY_OPERATIONS"] = "TOO_MANY_OPERATIONS";
    BeaconErrorType["TRANSACTION_INVALID_ERROR"] = "TRANSACTION_INVALID_ERROR";
    BeaconErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR"; // Used as a wildcard if an unexpected error occured.
})(BeaconErrorType = exports.BeaconErrorType || (exports.BeaconErrorType = {}));
//# sourceMappingURL=BeaconErrorType.js.map